import styles from "../../styles/pages/Login/LoginPage.module.css";
import React, { useEffect, useState, useContext } from 'react';
import { Notification } from "../../components/UI/Notifications";
import { loginUser } from "../../utils/api/Auth/auth";

import { LangContext } from '../../context/LangContext';
import { ThemeContext } from '../../context/ThemeContext';
import { InputSelector } from "../../components/UI/InputSelector";
import { InputPasswordSelector } from "../../components/UI/InputPasswordSelector";
import { clearLoginAsSession } from "../../utils/custom/loginAsSession";


const translations = {
  ru: {
    loginTitle: 'Вход в CRM',
    usernameLabel: 'Логин:',
    passwordLabel: 'Пароль:',
    loginButton: 'Войти',
    errorMessageDefault: 'Произошла ошибка при отправке данных.'
  },
  en: {
    loginTitle: 'CRM Login',
    usernameLabel: 'Username:',
    passwordLabel: 'Password:',
    loginButton: 'Login',
    errorMessageDefault: 'An error occurred while submitting data.'
  },
};


export const LoginPage = ({ setIsLogin }) => {

  const { langSelected } = useContext(LangContext);
  const { theme } = useContext(ThemeContext);

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');


  const [isUsernameFocused, setIsUsernameFocused] = useState(false);
  const [isPasswordFocused, setIsPasswordFocused] = useState(false);


  const currentTranslation = translations[langSelected] || translations.ru;

  useEffect(() => {
    if (errorMessage) {
      const timer = setTimeout(() => {
        setErrorMessage('');
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [errorMessage]);


  const handleUsernameChange = (name, value) => {
    setUsername(value);
  };

  const handlePasswordChange = (name, value) => {
    setPassword(value);
  };


  const handleFocus = (field) => {
    if (field === 'username') setIsUsernameFocused(true);
    if (field === 'password') setIsPasswordFocused(true);
  };

  const handleBlur = (field) => {
    if (field === 'username') setIsUsernameFocused(false);
    if (field === 'password') setIsPasswordFocused(false);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      const data = await loginUser(username, password)
      clearLoginAsSession();
      localStorage.setItem('token', data.token)

      // store realtime target id (used by notifications subscription)
      if (data.admin?.id) {
        localStorage.setItem("admin_id", String(data.admin.id));
      } else {
        localStorage.removeItem("admin_id");
      }

      let userData = {
        userRole: "",
        first_name: null,
        last_name: null
      };
      if (data.admin) {
        userData = {
          userRole: "Admin",
          first_name: data.admin.first_name,
          last_name: data.admin.last_name
        }
      } else if (data.affiliator) {
        userData = {
          userRole: "Affiliator",
          first_name: null,
          last_name: null
        }
      } else {
        userData = {
          userRole: "Unknown",
          first_name: null,
          last_name: null
        }
      }

      const loginData = {
        isLoggedIn: true,
        userData
      }

      localStorage.setItem('login', JSON.stringify(loginData))
      setIsLogin(loginData)

    } catch (err) {
      console.error("Ошибка:", err);
      if (err && err.errors && err.errors[0]?.message) {
        setErrorMessage(err.errors[0].message);
      } else {
        setErrorMessage(currentTranslation.errorMessageDefault);
      }
    }
  };

  return (
    <div className={`${styles.loginContainer} ${theme === 'dark' ? styles.darkLoginContainer : ''}`}>
      {errorMessage && (
        <Notification message={errorMessage} type="error" />
      )}
      <div className={`${styles.loginForm} ${theme === 'dark' ? styles.darkLoginForm : ''}`}>
        <h2 className={styles.title}>{currentTranslation.loginTitle}</h2>
        <form onSubmit={handleSubmit}>

          <div className={styles.formGroup}>
            <label htmlFor="username" className={`${theme === 'dark' ? styles.darkLabel : ''}`}>{currentTranslation.usernameLabel}</label>
            <InputSelector
              filterName="username"
              selectedValue={username}
              handleFilterChange={handleUsernameChange}
              onFocus={() => handleFocus('username')}
              onBlur={() => handleBlur('username')}
              isFocused={isUsernameFocused}
              type="text"
              isDark={theme === 'dark'}

            />
          </div>

          <div className={styles.formGroup}>
            <label htmlFor="password" className={`${theme === 'dark' ? styles.darkLabel : ''}`}>{currentTranslation.passwordLabel}</label>
            <InputPasswordSelector
              filterName="password"
              selectedValue={password}
              handleFilterChange={handlePasswordChange}
              onFocus={() => handleFocus('password')}
              onBlur={() => handleBlur('password')}
              isFocused={isPasswordFocused}
              isDark={theme === 'dark'}
            />
          </div>
          <button type="submit" className={`${styles.button} ${theme === 'dark' ? styles.darkButton : ''}`}>{currentTranslation.loginButton}</button>
        </form>
      </div>
    </div>
  );
};
